import { getData } from "./cors";

export async function getCountries() {
  try {
    let response = await fetch("/api/countries.php", getData);
    let responseJson = await response.json();
    console.log(responseJson);
    return responseJson;
  } catch (e) {
    return e;
  }
}

export async function getStates() {
  try {
    let response = await fetch("/api/states.php", getData);
    let responseJson = await response.json();
    console.log(responseJson);
    return responseJson;
  } catch (e) {
    return e;
  }
}

export async function getCities() {
  try {
    let response = await fetch("/api/cities.php", getData);
    let responseJson = await response.json();
    console.log(responseJson);
    return responseJson;
  } catch (e) {
    return e;
  }
}

export async function getNeighborhoods() {
  try {
    let response = await fetch("/api/neighborhoods.php", getData);
    let responseJson = await response.json();
    console.log(responseJson);
    return responseJson;
  } catch (e) {
    return e;
  }
}
